import { useEffect, useState } from "react";

interface VariablePopupProps {
  variables: string[];
  defaultValues?: Record<string, number>;
  onSave: (values: Record<string, number>) => void;
  onBack: () => void;
}

const VariablePopup: React.FC<VariablePopupProps> = ({ variables, defaultValues, onSave, onBack }) => {

  const [values, setValues] = useState<Record<string, string>>({});

  useEffect(() => {
    if (defaultValues && typeof defaultValues === "object") {
      const stringValues = Object.fromEntries(
        Object.entries(defaultValues).map(([k, v]) => [k, String(v)])
      );
      setValues(stringValues);
    }
  }, [defaultValues]);

  return (

    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 pointer-events-auto">

      <div className="bg-white p-6 rounded shadow-lg w-[90%] max-w-[420px] max-h-[700px] overflow-y-auto">

        <h3 className="text-lg font-semibold mb-4">
          Variable Values
        </h3>

        <div className="space-y-3 pr-1">

          {variables.map((v, i) => (
            <div key={`${v}-${i}`} className="flex flex-col">

              <label className="text-sm text-left font-bold">
                {v}
              </label>

              <input
                type="number"
                style={{ MozAppearance: "textfield" }}
                className="border p-2 rounded [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                value={values[v] ?? ""}
                onChange={(e) =>
                  setValues({
                    ...values,
                    [v]: e.target.value
                  })
                }
              />

            </div>
          ))}

        </div>

        <div className="flex justify-center gap-3 mt-5">

          <button
            className="bg-black text-white px-10 py-2 grow md:grow-0 rounded-full font-bold "
            onClick={() => onBack()}
          >
            Back
          </button>

          <button
            className="bg-primary px-10 py-2 grow md:grow-0 rounded-full font-bold text-white disabled:bg-gray-300 disabled:text-gray-500"
            onClick={() =>
              onSave(
                Object.fromEntries(
                  Object.entries(values).map(([k, v]) => [k, Number(v)])
                )
              )
            }
          >
            Save
          </button>

        </div>

      </div>

    </div>

  );
};

export default VariablePopup;